import { render, staticRenderFns } from "./TenancyTests.vue?vue&type=template&id=d6559b74&scoped=true&"
import script from "./TenancyTests.vue?vue&type=script&lang=ts&"
export * from "./TenancyTests.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6559b74",
  null
  
)

export default component.exports